import { __assign, __generator } from "tslib";
import { select, fork, take, delay, put, 
/* https://youtu.be/uq-gYOrU8bA */
/* you can */ call, 
/* me */ all, } from 'redux-saga/effects';
import { uploadFailure, uploadSuccess, uploadProgress, reloadStashStream, reloadStashStreamDone, } from '../actions';
import { getCurrentFolderId, getFileUploadsInfo } from '../selectors';
import { createReduxChannel } from './uploadFile';
import ddt from '@wix/da-ddt';
var MAX_CONCURRENT_UPLOADS_ALLOWED = 10;
function uploadFileSaga(payload) {
    var file, folderId, channel, _a, _b, progress, error, success;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                file = payload.file;
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 1:
                folderId = _c.sent();
                return [4 /*yield*/, call(createReduxChannel, {
                        file: file,
                        folderid: folderId,
                    })];
            case 2:
                channel = _c.sent();
                _c.label = 3;
            case 3:
                if (!true) return [3 /*break*/, 13];
                return [4 /*yield*/, take(channel)];
            case 4:
                _a = _c.sent(), _b = _a.progress, progress = _b === void 0 ? 0 : _b, error = _a.error, success = _a.success;
                if (!error) return [3 /*break*/, 6];
                return [4 /*yield*/, put(uploadFailure(__assign(__assign({}, payload), { folderId: folderId, error: error })))];
            case 5:
                _c.sent();
                return [2 /*return*/];
            case 6:
                if (!success) return [3 /*break*/, 11];
                return [4 /*yield*/, put(uploadSuccess(__assign(__assign({}, payload), { folderId: folderId })))];
            case 7:
                _c.sent();
                return [4 /*yield*/, delay(1000)];
            case 8:
                _c.sent(); // wait arbitrary 1s for stash to update
                return [4 /*yield*/, put(reloadStashStream())];
            case 9:
                _c.sent();
                return [4 /*yield*/, take(reloadStashStreamDone)];
            case 10:
                _c.sent(); // wait for reload to complete
                return [2 /*return*/];
            case 11: return [4 /*yield*/, put(uploadProgress(__assign(__assign({}, payload), { folderId: folderId, progress: progress })))];
            case 12:
                _c.sent();
                return [3 /*break*/, 3];
            case 13: return [2 /*return*/];
        }
    });
}
function uploadFilesSaga(action) {
    var activeUploads, newFileUploads, remainingUploadSlots;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getFileUploadsInfo)];
            case 1:
                activeUploads = _a.sent();
                newFileUploads = action.payload;
                remainingUploadSlots = Math.max(0, MAX_CONCURRENT_UPLOADS_ALLOWED - activeUploads.length);
                if (remainingUploadSlots > newFileUploads.length) {
                    ddt.error('MediaManager', 'Maximum concurrent file uploads exceeded. Truncating...', newFileUploads.slice(remainingUploadSlots));
                }
                return [4 /*yield*/, put(reloadStashStream())];
            case 2:
                _a.sent();
                return [4 /*yield*/, take(reloadStashStreamDone)];
            case 3:
                _a.sent(); // wait for reload to complete
                return [4 /*yield*/, all(newFileUploads
                        .slice(0, remainingUploadSlots)
                        .map(function (file) { return fork(uploadFileSaga, file); }))];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default uploadFilesSaga;
//# sourceMappingURL=uploadFiles.js.map